import { render, staticRenderFns } from "./EventContestEntry.vue?vue&type=template&id=449fa524&scoped=true"
import script from "./EventContestEntry.vue?vue&type=script&lang=ts"
export * from "./EventContestEntry.vue?vue&type=script&lang=ts"
import style0 from "./EventContestEntry.vue?vue&type=style&index=0&id=449fa524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449fa524",
  null
  
)

export default component.exports